import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'duotone-shirt-svg-icon',
    templateUrl: 'duotone-shirt-svg-icon.component.html',
    standalone: false
})

export class DuotoneShirtSvgIconComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
